import React, { useEffect, useState } from "react";
import sanityClient from "../client";
import "./styles/SponsorsCarousel.scss";

export default function SponsorsGrid() {
  const [sponsors, setSponsors] = useState([]);
  const [visibleSponsors, setVisibleSponsors] = useState([]);
  const [index, setIndex] = useState(0);

  // Fetch sponsors from Sanity
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "sponsor"]{
          "logo": logo.asset->url,
          website
        }`
      )
      .then((data) => {
        // Randomize the sponsors' order
        const shuffledSponsors = data.sort(() => 0.5 - Math.random());
        setSponsors(shuffledSponsors);
        setVisibleSponsors(shuffledSponsors.slice(0, 3));
      })
      .catch((error) => console.error(error));
  }, []);

  // Cycle through sponsors every 5 seconds with fade effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => {
        const nextIndex = (prevIndex + 3) % sponsors.length;
        document.querySelector(".grid-container").classList.add("fade-out");

        setTimeout(() => {
          setVisibleSponsors(sponsors.slice(nextIndex, nextIndex + 3));
          document.querySelector(".grid-container").classList.remove("fade-out");
        }, 500); // Matches the fade-out duration

        return nextIndex;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [sponsors]);

  return (
    <div className="sponsors-grid">
      <h2 className="sponsors-heading">Thank You to Our Sponsors</h2>
      <div className="grid-container">
        {visibleSponsors.map((sponsor, index) => (
          <a
            key={index}
            href={sponsor.website || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="sponsor-item"
          >
            <img src={sponsor.logo} alt={`Sponsor ${index + 1}`} />
          </a>
        ))}
      </div>
    </div>
  );
}